import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

export interface Props {
  establishmentCompanyBranchId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

const useRemoveEstablishmentCompanyBranchImage = ({
  establishmentCompanyBranchId,
  onSuccess,
  onError,
}: Props) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['removeEstablishmentCompanyBranchImage', establishmentCompanyBranchId],
    mutationFn: async (photoId: string) => {
      const photos_attachments_attributes = [
        { id: photoId, _destroy: true },
      ];

      return privateAxios.put(`/establishment/company_branches/${establishmentCompanyBranchId}`, {
        company_branch: { photos_attachments_attributes }
      });
    },
    onSuccess,
    onError,
  })
}

export default useRemoveEstablishmentCompanyBranchImage
